import { makeStyles, Theme } from "@material-ui/core";

import { colors, fonts, loadingDark } from "../../shared/styles";

const useMainStyles = makeStyles(({ breakpoints, palette }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.white,
    gap: '16px',
    padding: '16px',

    [breakpoints.up('sm')]: {
      flexDirection: 'row',
    }
  },
  leftSide: {
    [breakpoints.up('sm')]: {
      flex: '0 0 300px',
    }
  },
  rightSide: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: '16px',
  },
  shadowWrapper: {
    boxShadow: colors.cardShadow,
  },
}))

const useAthleteCardStyles = makeStyles(({ breakpoints, palette }) => ({
  bibContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  bibNumber: {
    border: `1px solid ${colors.grey}`,
    borderTop: 'none',
    color: colors.textColor,
    fontFamily: fonts.heavy.fontFamily,
    fontSize: '14px',
    lineHeight: '20px',
    padding: '4px 8px',
  },
  bibNumberWrapper: {
    width: 'fit-content',

    '& > div': {
      borderTop: '3px solid #16A9E1',
    }
  },
  bibTitle: {
    color: colors.grey,
    display: 'none',
    fontFamily: fonts.heavy.fontFamily,
    fontSize: '12px',
    lineHeight: '16px',

    [breakpoints.up('sm')]: {
      display: 'initial',
    }
  },
  bibWrapper: {
    alignItems: 'center',
    display: 'flex',
    gap: '16px',
    marginTop: '8px',
    
    [breakpoints.up('sm')]: {
      flexDirection: 'column',
      marginTop: '12px',
    }
  },
  body: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    width: '100%',

    [breakpoints.up('sm')]: {
      margin: '16px 0 0',
    },
  },
  container: {
    alignItems: 'center',
    display: 'flex',
    gap: '16px',
    padding: '20px',
    width: '100%',

    [breakpoints.up('sm')]: {
      flexDirection: 'column',
      gap: 0,
      justifyContent: 'center',
    }
  },
  details: {
    color: colors.grey,
    fontFamily: fonts.default.fontFamily,
    fontSize: '14px',
    lineHeight: '20px',
  },
  detailsDivider: {
    borderRight: `1px solid ${colors.grey}`,
    height: '16px',
    margin: '0 8px',
  },
  detailsContainer: {
    alignItems: 'center',
    display: 'flex',
  },
  displayName: {
    color: colors.textColor,
    fontFamily: fonts.heavy.fontFamily,
    fontSize: '24px',
    lineHeight: '32px',
  },
  followButton: {
    backgroundColor: palette.brandColor,
    color: '#fff',
    padding: '4px 28px',
    width: 'fit-content',
    
    '&:hover': {
      backgroundColor: palette.brandColor,
    },
  },
  skeletonDisplayName: {
    ...loadingDark,
    height: '24px',
    margin: '4px 0',
    width: '80%',
  },
  skeletonDetails: {
    ...loadingDark,
    height: '14px',
    margin: '3px 0',
    width: '60%',
  },
}))

const useAthletePhotoStyles = makeStyles<Theme, {
  backgroundImage: string
  isSkeletonActive: boolean
}>(({ breakpoints, palette }) => ({
  container: ({ backgroundImage }) => ({
    alignItems: 'center',
    background: `url(${backgroundImage}) center / cover no-repeat`,
    borderRadius: '50%',
    display: 'flex',
    height: '82px',
    justifyContent: 'center',
    overflow: 'hidden',
    width: '82px',

    [breakpoints.up('sm')]: {
      height: '152px',
      width: '152px',
    }
  }),
  initials: ({ isSkeletonActive }) => ({
    ...fonts.bold,
    color: colors.textColor,
    display: isSkeletonActive ? 'none' : 'block',
    fontSize: '32px',
    lineHeight: '40px',

    [breakpoints.up('sm')]: {
      fontSize: '56px',
      lineHeight: '64px',
    }
  }),
  picture: ({ isSkeletonActive }) => ({
    display: isSkeletonActive ? 'none' : 'block',
    height: '100%',
    objectFit: 'cover',
    width: '100%',
  }),
  skeleton: {
    height: '100%',
    width: '100%',
    ...loadingDark,
  },
  wrapper: {
    border: `4px solid ${palette.brandColor}`,
    borderRadius: '50%',
    padding: '4px',
  },
}))

const useEventCardStyles = makeStyles(() => ({
  container: {
    padding: '20px'
  },
  details: {
    color: colors.grey,
    fontFamily: fonts.default.fontFamily,
    fontSize: '14px',
    lineHeight: '20px',
  },
  detailsDivider: {
    borderRight: `1px solid ${colors.grey}`,
    height: '16px',
    margin: '0 8px',
  },
  detailsContainer: {
    alignItems: 'center',
    display: 'flex',
  },
  eventName: {
    fontSize: '18px',
    lineHeight: '24px',
  },

  skeletonEventName: {
    ...loadingDark,
    height: '18px',
    margin: '3px 0',
    width: '100%',
  },
  skeletonDetails: {
    ...loadingDark,
    height: '14px',
    margin: '6px 0 3px',
    width: '100%',
  },
}))

export {
  useMainStyles,
  useAthleteCardStyles,
  useAthletePhotoStyles,
  useEventCardStyles,
}